<!-- @format -->

<ng-container *transloco="let t">
  <sis-study-box
    [id]="customModuleAttainment?.id"
    [name]="customModuleAttainment?.name"
    [gradeScaleId]="customModuleAttainment?.gradeScaleId"
    [gradeId]="customModuleAttainment?.gradeId"
    [code]="customModuleAttainment?.code"
    [attainedCredits]="customModuleAttainment?.credits"
    [type]="studyBoxType"
    [credits]="visibleCredits"
    [level]="headingLevel"
    [action]="action"
    [selected]="selected"
    (actionChange)="actionChange.emit($event)">
    <ng-container study-box="notifications">
      <sis-study-notification-box
        *ngIf="customModuleAttainmentStateObject?.invalidSelection && !this.customModuleAttainmentStateObject?.hasModuleContentApproval"
        type="alert">
        {{ t("SIS_COMPONENTS.STUDY.INVALID_SELECTION") }}
      </sis-study-notification-box>
      <sis-study-notification-box
        *ngIf="customModuleAttainmentStateObject?.isInvalidAccordingToModuleContentApprovalRequested"
        type="alert"
        >{{ t("SIS_COMPONENTS.STUDY.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL") }}</sis-study-notification-box
      >
      <sis-study-notification-box
        *ngIf="customModuleAttainmentStateObject?.isInvalidAccordingToModuleContentApprovalAccepted"
        type="alert"
        >{{ t("SIS_COMPONENTS.STUDY.CONTENT_NOT_AS_APPROVED") }}</sis-study-notification-box
      >
      <sis-study-notification-box *ngIf="customModuleAttainmentStateObject?.isAttainmentAboutToExpire" type="info">{{
        t("SIS_COMPONENTS.STUDY.EXPIRATION_IMMINENT", {
          expiryDate: customModuleAttainmentStateObject.attainmentExpiryDate | localDateFormat,
        })
      }}</sis-study-notification-box>
    </ng-container>
  </sis-study-box>
</ng-container>
